import { noop } from '@openx/utils/noop.ts';
import { createContext } from 'react';
import type { ConfigContextValue } from './types.ts';

export const configContext = createContext<ConfigContextValue>({
  registerLocalErrorHandler: () => {
    noop();
  },
  unregisterLocalErrorHandler: () => {
    noop();
  },
});
